import React from 'react'
import styled from 'styled-components'

const FormRefarensImage: React.FC<FormRefarensImageProps> = (props) => {
  const determineWidth = (fileNmae?: string): string => {
    if (fileNmae?.includes('full')) return 'min( 100%, 720px ) '
    if (fileNmae?.includes('half')) return 'min( 50%, 360px )'
    return '100%'
  }

  return (
    <ImgArea>
      <StyledImg src={props.image} width={determineWidth(props.image)} />
    </ImgArea>
  )
}

const StyledImg = styled.img<{ width?: string }>`
  display: block;
  width: ${(props): string => props.width || 'auto'};
  height: auto;
  border-radius: calc(18px);
`

const ImgArea = styled.div`
  margin: 0 16px 10px;
`

export type FormRefarensImageProps = {
  image?: string
}

export default FormRefarensImage
